export default "__VITE_ASSET__DdZQ8cHY__"